import { Component } from '@angular/core';

@Component({
  selector: 'app-failed',
  templateUrl: './failed.component.html',
  styleUrls: ['./failed.component.scss'],
  standalone: false,
})
export class FailedComponent {
  constructor() {}
}
